import { useGlue } from './useGlue';
import { useEffect, useState } from 'react';
import { GlueEvents } from '../glue';

function useFiltered(kind, value) {
  const glue = useGlue();
  const [newValue, setValue] = useState(glue.applyFilter(kind, value));
  useEffect(() => glue.on(GlueEvents.ADD_FILTER_PREFIX + kind, () => {
    setValue(glue.applyFilter(kind, value));
  }));
  return newValue;
}

export { useFiltered };